import AmexGDAEditorial from './AmexGDAEditorial';

export default AmexGDAEditorial;
